<template>
  <!-- 核销查询组件 -->
  <div class="Warp">
    <!-- 列表 start-->
    <van-grid :column-num="3" :border="false">
      <van-grid-item text="姓名" />
      <van-grid-item text="卡券名称" />
      <van-grid-item text="使用状态" />
    </van-grid>
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="uploader"
        >
            <van-cell v-for="item in list"  :key="item.id" @click="toDetail(item)">
                <van-grid :column-num="3" :border="false">
                    <van-grid-item :text="item.name" />
                    <van-grid-item :text="item.title" />
                    <van-grid-item v-if="item.use_status == 1">已核销</van-grid-item>
                    <van-grid-item v-if="item.use_status == 0">未使用</van-grid-item>
                </van-grid>
            </van-cell>
        </van-list>
        <!-- 列表 end-->
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  props: {
    merchant_id: Number,
  },
  data() {
    return {
      page: 0,
      limit: 10,
      list: [],
      loading: false,
      finished: true,
      refreshLoading:false,

    };
  },
  mounted() {
    console.log('mounted');
    this.getList();
  },
  methods: {
    getList() {
      var reqData = {
        salesman_id: this.$cookie.get("salesmanInfo").id,
        merchant_id: this.merchant_id,
        page: this.page,
        limit: this.limit,
      };
      this.$http
        .post("/wechat/api.salesman/userCoupons", reqData, { emulateJSON: true })
        .then((res1) => {
          var res = res1.body;
          console.log(res);
          res.data.rows.map((v) => {
            this.list.push(v);
          });
          this.loading = false;
          this.refreshLoading = false;
          console.log(this.list);
          if (this.list.length >= res.data.count) {
            console.log(111);
            this.finished = true;
          }else{
            this.finished=false;
          }
        });
    },
    // 上拉加载
    uploader() {
      console.log('uploader');
      this.page++;
      this.getList();
    },
    // 下拉刷新
    onRefresh(){
      console.log('onRefresh');
      this.page=0;
      this.list = [];
      this.finished=true;
      this.getList()
    },
    toDetail(item){
      this.$router.push({
        path:'/verificationDetail',
        query:item
      }) 
    }
  },
};
</script>
<style lang="less" scoped>
</style>